let promoDialog = false;
let sidebar = false;
let loggedIn = false;
let navGuardBlock = false;
let navGuardText = '';
let callbackId = '';

export function isLoggedIn() {
    return loggedIn;
}

export function setLoggedIn(val) {
    loggedIn = val;
}

export function setCallbackId(val) {
    callbackId = '' + val;
}

export function getCallbackId() {
    return callbackId;
}


export function isNavGuardBlock() {
    return navGuardBlock;
}

export function setNavGuardBlock(val, text) {
    navGuardBlock = val;
    if (text) {
        navGuardText = text;
    }
}

export function getNavGuardText() {
    return navGuardText;
}

export function isPromoDialog() {
    return promoDialog;
}

export function setPromoDialog(val) {
    promoDialog = val;
}

export function setSidebar(val) {
    sidebar = val;
}

export function isSidebar() {
    return sidebar;
}
